import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@config/env";

const post = (ep, fields) => { const fd=new FormData(); Object.entries(fields).forEach(([k,v])=>fd.append(k,v)); return axios.post(`${API_BASE}${ep}`,fd).then(r=>r.data).catch(()=>null); };

export default function VerifyEmailPage() {
  const { link } = useParams();
  const [checking, setChecking] = useState(true);
  const [success,  setSuccess]  = useState(false);
  const [message,  setMessage]  = useState("");

  useEffect(() => {
    if (!link) { setChecking(false); setMessage("Verification link is not valid. Please check the link and try again."); return; }
    post("get-link-details", { link }).then(data => {
      setSuccess(data?.status === 1);
      // TEMP: appending data.debug while diagnosing the missing password email - remove once resolved
      const base = data?.message || "Something went wrong. Please try again later.";
      setMessage(data?.debug ? `${base} (${data.debug})` : base);
      setChecking(false);
    });
  }, [link]);

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ width:"100%", maxWidth:440 }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:22, fontWeight:800, color:"#111827", letterSpacing:"-0.03em" }}>Firm<span style={{color:"#2563EB"}}>Connector</span></div>
        </div>
        <div style={{ background:"#fff", borderRadius:20, boxShadow:"0 4px 24px rgba(0,0,0,0.06)", padding:"32px 32px 28px", border:"1px solid #E5E7EB", textAlign:"center" }}>
          {checking ? (
            <>
              <div style={{ width:44, height:44, borderRadius:12, background:"#EFF6FF", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px" }}>
                <i className="fa-solid fa-spinner fa-spin" style={{ fontSize:18, color:"#2563EB" }} />
              </div>
              <h1 style={{ fontSize:20, fontWeight:800, color:"#111827", margin:0 }}>Verifying your email...</h1>
              <p style={{ fontSize:13, color:"#6B7280", margin:"6px 0 0" }}>This will just take a moment.</p>
            </>
          ) : success ? (
            <>
              <div style={{ width:44, height:44, borderRadius:12, background:"#F0FDF4", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px" }}>
                <i className="fa-solid fa-circle-check" style={{ fontSize:18, color:"#16A34A" }} />
              </div>
              <h1 style={{ fontSize:20, fontWeight:800, color:"#111827", margin:0 }}>Email confirmed!</h1>
              <p style={{ fontSize:13.5, color:"#374151", margin:"10px 0 20px", lineHeight:1.6 }}>{message}</p>
              <Link to="/login" className="fc-btn fc-btn-md fc-btn-primary" style={{ display:"block", textAlign:"center", textDecoration:"none", borderRadius:10 }}>
                Go to Login
              </Link>
            </>
          ) : (
            <>
              <div style={{ width:44, height:44, borderRadius:12, background:"#FEF2F2", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px" }}>
                <i className="fa-solid fa-circle-exclamation" style={{ fontSize:18, color:"#DC2626" }} />
              </div>
              <h1 style={{ fontSize:20, fontWeight:800, color:"#111827", margin:0 }}>Verification issue</h1>
              <p style={{ fontSize:13.5, color:"#374151", margin:"10px 0 20px", lineHeight:1.6 }}>{message}</p>
              <Link to="/login" className="fc-btn fc-btn-md fc-btn-primary" style={{ display:"block", textAlign:"center", textDecoration:"none", borderRadius:10 }}>
                Go to Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
